module.exports = __webpack_public_path__ + "img/black-pencil.527b4493.svg";